/* eslint-disable react/react-in-jsx-scope */
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import AssetContacts from "./AssetContacts";

function AssetContactsSlider({ asset }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
        variant="link"
        className="bg-transparent p-0"
        onClick={handleShow}
        size="sm"
      >
        Contacts
      </Button>

      <Offcanvas
        style={{ width: "700px" }}
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Asset Contacts</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AssetContacts selectedAsset={asset} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AssetContactsSlider;
